import { useState } from 'react';
import { useDeleteEmployeeMutation } from '../../features/apis/authApi';
import ReactToastify from '../../hooks/useReactToastify';
import BaseModal from '../Common/BaseModal';

type deleteEmployeeType = {
  profileUser: {
    name: string | undefined;
    email: string | undefined;
    _id: string;
  };
  isOpened: boolean;
  onClose: () => void;
  refetch: () => void;
};

const DeleteEmployee = ({
  profileUser,
  refetch,
  isOpened,
  onClose,
}: deleteEmployeeType) => {
  const [loadingState, setLoadingState] = useState<boolean>(false);
  const [deleteEmployee] = useDeleteEmployeeMutation();

  const deleteHandler = async () => {
    setLoadingState(true);
    try {
      const response = await deleteEmployee({ id: profileUser._id }).unwrap();
      if (response) {
        console.log(response, 'delete response');

        refetch();
        setLoadingState(false);
        onClose();
        return ReactToastify({
          message: response.log,
          success: true,
        });
      }
    } catch (err: any) {
      console.log(err);
      setLoadingState(false);
      ReactToastify({
        message: `Unabale to delete  ${profileUser?.name}. Please Try Again`,
        success: false,
      });
    }
  };

  return (
    <BaseModal
      header={`You are deleting ${profileUser?.name?.toUpperCase()}`}
      isOpen={isOpened}
      onClose={onClose}
      showWarning
      warningMessage={`Deleting a user? User won't be able to use this portal. Activating Confirm it again before decativating an user.`}
      isLoading={loadingState}
      onSubmit={deleteHandler}
      submitText="Delete"
    >
      <></>
    </BaseModal>
  );
};

export default DeleteEmployee;
